export const CreditRejectReasons = {
  BANKID_ISSUE_DATE: 'BankIDIssueDate',
  BISNODE_REJECTED: 'BisnodeRejected',
  EXCEED_NUMBER_OF_LOANS: 'ExceedNumberOfLoans',
  EXISTING_CREDIT: 'ExistingCredit',
  EXISTING_LOAN: 'ExistingLoan',
  KALP_REJECTED: 'KalpRejected',
  OVERDUE_PAYMENTS: 'OverduePayments',
  PSD_LOW_INCOME: 'PsdLowIncome',
  RECENT_BISNODE_CALL: 'RecentBisnodeCall',
  TERMINATED_AGREEMENT: 'TerminatedAgreement',
  TERMINATED_LOAN: 'TerminatedLoan',
  UC_SCORE_MISSING: 'UCScoreMissing',
  UC_SERVICE_ERROR: 'UCServiceError',
  USER_BLOCKED: 'UserBlocked',
  PARTNER_REJECTED: 'PartnerRejected',
} as const;

export type CreditRejectReason = (typeof CreditRejectReasons)[keyof typeof CreditRejectReasons];

export const LevlaRejectReasons = {
  DIRECT_DEBIT_MANDATE_NOT_FOUND: 'DirectDebitMandateNotFound',
  ELIGIBILITY_CHECKER_REJECTED: 'EligibilityCheckerRejected',
  INTERNAL_SCORE: 'InternalScore',
  MAX_PRODUCT: 'MaxProduct',
  ONGOING_CHARGE: 'OngoingCharge',
  OVERDUE_PAYMENTS: 'OverduePayments',
  PAYMENTS_WITH_FEES: 'PaymentsWithFees',
  RECENT_BISNODE_CALL: 'RecentBisnodeCall',
  TOO_MANY_INQUIRIES: 'TooManyInquiries',
  UC_SCORE_MISSING: 'UCScoreMissing',
  UC_SERVICE_ERROR: 'UCServiceError',
  PAYMENT_FREE_MONTH: 'PaymentFreeMonth',
} as const;

export type LevlaRejectReason = (typeof LevlaRejectReasons)[keyof typeof LevlaRejectReasons];
